import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal, Button } from 'react-bootstrap';
import cx from 'classnames';

import s from './ConfirmationPopup.css';
import bt from '../../../components/commonStyle.css';

const ConfirmationPopup = (props) => {

    const { modalStatus, closeModal, title, popupButtonLeftName, popupButtonRightName, popupButtonLeftFunction, popupButtonRightFunction } = props;
    const { bodyText } = props;

    return (
        <Modal show={modalStatus} onHide={closeModal} dialogClassName='loginModal'>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass={s.logInModalBody}>
                <div className={s.root}>
                    {bodyText && <p className={s.confirmationPopupBodyText}>{bodyText}</p>}
                    <div className={s.confirmationPopupFooterBtnGrp}>
                        <Button className={bt.btnPrimary} onClick={() => popupButtonRightFunction()}>
                            {popupButtonRightName}
                        </Button>
                        <Button className={bt.btnPrimaryBorder} onClick={() => popupButtonLeftFunction()}>
                            {popupButtonLeftName}
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default withStyles(s, bt)(ConfirmationPopup);